import { Component, Input, OnInit, OnDestroy, TemplateRef, ContentChild, ViewChild, AfterViewInit } from '@angular/core';

import { Subscription } from 'rxjs';

import { RatingComponent } from 'ngx-bootstrap/rating';

import { IRules } from 'rev-shared/ui/css/CssRules.Contract';

import { BrandingSettings } from 'rev-portal/branding/BrandingSettings.Contract';
import { ThemeService } from 'rev-portal/branding/Theme.Service';

@Component({
	selector: 'vb-rating',
	templateUrl: './VbRating.Component.html'
})
export class VbRatingComponent implements OnInit, OnDestroy, AfterViewInit {
	@Input() public templateClass: string;
	@Input() public customTemplate: TemplateRef<any>;
	@ContentChild(RatingComponent) public ratingComponent: RatingComponent;
	@ViewChild('ratingTemplate', { read: TemplateRef }) public ratingTemplate: TemplateRef<any>;

	public themeServiceSub: Subscription;
	public themeStyleOverrides: IRules;

	constructor(
		private ThemeService: ThemeService
	) { }

	public ngOnInit(): void {
		this.themeServiceSub = this.ThemeService.brandingSettings$.subscribe(brandingSettings => this.applyCssRules(brandingSettings));
	}

	public ngAfterViewInit(): void {
		this.ratingComponent.customTemplate = this.customTemplate || this.ratingTemplate;
	}

	public ngOnDestroy(): void {
		this.themeServiceSub?.unsubscribe();
	}

	public applyCssRules(brandingSettings: BrandingSettings): void {
		const themeAccentColor = brandingSettings.themeSettings.accentColor;
		this.themeStyleOverrides = {
			['.bs-rating-star.active']: {
				'color': `${themeAccentColor} !important`
			}
		};
	}

}
